import { CookieBannerActions } from 'utils/enums';
import { deleteCookie, getCookie, setCookie } from 'utils/helpers';
import { COOKIE_ACCEPT, COOKIE_DECLINE, POS_COOKIE_SETTINGS } from 'utils/constants';
import { CookieDeclarationDto } from 'components/CookieBanner/types';

export const canShowCookieBanner = (): boolean => {
  const showBanner = getCookie(POS_COOKIE_SETTINGS);
  if (!showBanner) return true;
  return showBanner === 'true';
};
export const handleCookieBannerActions = (
  action: CookieBannerActions,
  response: CookieDeclarationDto[]
) => {
  if (action === CookieBannerActions.Accept) {
    setCookie(POS_COOKIE_SETTINGS, COOKIE_ACCEPT, 1825);

    const nonScriptCookies = response.filter((cookie: CookieDeclarationDto) => !cookie.isScript);
    nonScriptCookies.forEach((cookie: CookieDeclarationDto) => {
      setCookie(cookie.name, cookie.value, cookie.maxAgeInDays);
    });
  }

  if (action === CookieBannerActions.Decline) {
    setCookie(POS_COOKIE_SETTINGS, COOKIE_DECLINE, 1);

    const optionalCookies = response.filter(
      (cookie: CookieDeclarationDto) => !cookie.isScript && !cookie.isMandatory
    );
    optionalCookies.forEach((cookie: CookieDeclarationDto) => {
      deleteCookie(cookie.name);
    });
  }
};
